var path = 'templates/dashboard.html';
var html = "<md-toolbar class=toolbar layout=row style=\"min-height:50px;box-shadow:0 0 10px 0 rgba(0,0,0,.7);z-index:999\" ng-include=\"'templates/partial/header.html'\"> </md-toolbar> <md-content class=dashboard id=container layout=row style=height:100%> <md-sidenav hide-xs layout-xs=hide style=width:230px class=\"md-sidenav-left sidenav\" md-component-id=left md-is-locked-open=true md-whiteframe=2 ng-include=\"'templates/partial/sidenav.html'\"> </md-sidenav> <md-content flex ui-view style=width:100%;height:100% layout=row> </md-content> </md-content> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/dashboard.html
// module id = 6
// module chunks = 0